export default {
  brand: {
    secondary: '#1db954',
    primary: '#102b2b',
  },
};
